const { createApp } = Vue;

var keys = step_data.reduce((prev, current) => {
  if (current.metafield) {
    return [...prev, current.metafield];
  } else {
    return [...prev, "upsell"];
  }
}, []);

var app = createApp({
  data() {
    return {
      products: all_products,
      current_step: 0, // zero based,
      total_steps: step_data.length,
      step_keys: keys,

      filtered_products: [], //first step has all products, all steps need value? OR when at 0 go to upsell?
      filtered_upsells: [],

      step_data: step_data,

      selected_options: [],
      selected_upsells: [],
      selected_upsell_keys: [], //need to know if selected choice is general upsell or select

      last_step: false,

      modal_open: false,
      modal_content: {
        type: "product",
        heading: "",
        body: "",
        image: "",
        price: "",
        url: "",
      },

      final_data: final_data,

      direction: 0, //determines the animation,

      money_format: money_formatting,
    };
  },
  mounted() {
    var intial_filtered = this.getFilteredData(
      this.current_step,
      this.products,
    );
    this.filtered_products[this.current_step] = intial_filtered[0];
    this.filtered_upsells[this.current_step] = intial_filtered[1];

    //set the button height to allow mobile components to be centered / inview
    var button_container = document.querySelector(".cb-step__controls");
    if (button_container) {
      var button_height = button_container.getBoundingClientRect().height;
      document.documentElement.style.setProperty(
        "--button-height",
        `${button_height}px`,
      );
    }

    //show product modal if form posted (errors/success)
    var url_search = window.location.search;
    if (url_search.includes("contact_posted")) {
      //pre open modal
      this.modal_content.type = "contact";
      this.modal_open = true;
    }

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // // We listen to the resize event
    // window.addEventListener('resize', () => {
    // // We execute the same script as before
    // let vh = window.innerHeight * 0.01;
    // document.documentElement.style.setProperty('--vh', `${vh}px`);
    // });
  },
  computed: {
    currentOptions() {
      return this.filtered_products[this.current_step];
    },
    currentUpsells() {
      return this.filtered_upsells[this.current_step] || {};
    },
    currentStepValue() {
      var filtered_value = this.filtered_products[this.current_step + 1];
      var current_key = this.step_keys[this.current_step];

      if (!filtered_value || !current_key) return false;

      return filtered_value[0][current_key];
    },
    finalProducts() {
      return this.filtered_products[this.current_step][
        this.selected_options[this.current_step]
      ];
    },
  },
  methods: {
    handleClick(products) {
      this.filtered_products = [...products];
    },
    setStep(index) {
      //Hide modal to show desired step
      if (this.modal_open) {
        this.modal_open = false;
      }

      if (index < this.current_step) {
        this.direction = -1;
      } else {
        this.direction = 1;
      }
      this.current_step = index;
    },
    incrementStep(increment) {
      var final_step = this.current_step + increment;
      this.direction = 1;
      if (increment < 0) {
        //previous
        this.direction = -1;
        //some steps wont have values for selected path, loop backwards to find closest step
        for (let i = this.current_step - 1; i >= 0; i--) {
          const value = this.selected_options[i];
          if (value) {
            final_step = i;
            break;
          }
        }
      }
      this.setStep(final_step);
    },
    //chosen options gets fed into getFilteredData to calculate next step
    setFilteredProducts(
      selected_option,
      filtered_products,
      upsell_products = [],
      upsell_key,
    ) {
      if (!filtered_products) return;

      if (
        this.selected_options[this.current_step] &&
        this.selected_options[this.current_step] != selected_option
      ) {
        //already has a value that is different for the current step
        this.resetData();
      }

      //set upsell product
      if (upsell_products[0]) {
        this.selected_upsells[this.current_step] = upsell_products;
        this.selected_upsell_keys[this.current_step] = upsell_key;
      } else {
        this.selected_upsells[this.current_step] = undefined; //clear off for when user navigates back
        this.selected_upsell_keys[this.current_step] = undefined;
      }

      this.selected_options[this.current_step] = selected_option;

      //replace step with updated value
      for (let i = this.current_step + 1; i < this.step_keys.length; i++) {
        const key = this.step_keys[i];

        if (key == "upsell") {
          //handle upsell
          var upsell_filtered = this.handleUpsell(i);
          this.filtered_products[i] = upsell_filtered[0];
          this.filtered_upsells[i] = upsell_filtered[1];
          this.setStep(i);

          return;
        }

        //go until you hit a step that has a value
        var latest_filtered = this.getFilteredData(i, filtered_products);

        if (Object.keys(latest_filtered[0])[0]) {
          //has values for current
          this.filtered_products[i] = latest_filtered[0];
          this.filtered_upsells[i] = latest_filtered[1];

          //go to next slide
          this.setStep(i);

          return;
        }
      }

      //has no more future options that are possible and no more upsells -> send to final step
      //send previous step to final

      //being at final should be determined if current_step == step_keys.length -> if I get to this point of the for loop, this is true

      var final_step_index = this.step_keys.length;

      if (!this.filtered_products[final_step_index]) {
        //doesn't have a final step -> add final to the end of the selected options
        //end regardless of values
        this.selected_options[final_step_index] =
          this.selected_options[this.current_step];
        this.filtered_products[final_step_index] =
          this.filtered_products[this.current_step];
        this.filtered_upsells[final_step_index] =
          this.filtered_products[this.current_step];
      }

      this.current_step = final_step_index;
    },
    handleUpsell(index) {
      var upsell_data = this.step_data[index].upsell_products; //all the product that belong to this upsell
      var select_data = this.step_data[index].upsell_select;
      var mount_data = this.step_data[index].upsell_mount || [];
      var car_data = this.step_data[index].upsell_car || [];
      var required = this.step_data[index].upsell_required || {}; //array?

      var current_filtered = this.filtered_products[this.current_step]; //propegate current as upsell has no filtering

      return [
        current_filtered,
        {
          mount: [mount_data, car_data],
          upsell: upsell_data,
          select: select_data,
          required: required,
        },
      ];
    },
    getFilteredData(step, data) {
      var sorted = {};
      var upsell = {};
      const current_key = this.step_keys[step];

      //loop through
      data.forEach((product) => {
        //sort by current step

        let current_product_value = product[current_key];

        if (typeof current_product_value == "object") {
          // //product has upsell for this step
          if (current_product_value[1]) {
            if (!upsell[current_product_value[0]]) {
              //if sorted hasnt had value before, create new array
              upsell[current_product_value[0]] = [];
              upsell[current_product_value[0]].push(current_product_value[1]);
            } else {
              //already contains value

              //check to see if value is already in there
              var found = upsell[current_product_value[0]].find((product) => {
                return current_product_value[1].id == product.id;
              });

              if (!Object.keys(found)[0]) {
                //only add if not already in
                upsell[current_product_value[0]].push(current_product_value[1]);
              }
            }
          }

          current_product_value = current_product_value[0];
        }

        if (current_product_value) {
          //some products have multiple values (tags) for a single product, split sting and handle component individually
          if (current_product_value.indexOf(",") >= 0) {
            //has multiple products
            let current_product_array = current_product_value.split(",");
            current_product_array.forEach((value) => {
              if (!sorted[value]) {
                //if sorted hasnt had value before, create new array
                sorted[value] = [];
              }
              sorted[value].push(product);
            });
          } else {
            if (!sorted[current_product_value]) {
              //if sorted hasnt had value before, create new array
              sorted[current_product_value] = [];
            }
            sorted[current_product_value].push(product);
          }
        }
      });

      //set upsell based of step data
      var current_step_data = this.step_data[step];
      if (
        current_step_data.upsell_products &&
        current_step_data.upsell_products[0]
      ) {
        current_step_data.upsell_products.forEach((item) => {
          if (!upsell[item.key]) {
            //if sorted hasnt had value before, create new array
            upsell[item.key] = [];
          }

          upsell[item.key].push(item.product);
        });
      }
      return [sorted, upsell];
    },
    resetData() {
      var reset_filtered = this.filtered_products.filter((prod, index) => {
        return index < this.current_step + 1;
      });

      var reset_upsells = this.selected_upsells.filter((option, index) => {
        return index < this.current_step;
      });

      var reset_options = this.selected_options.filter((option, index) => {
        return index < this.current_step;
      });

      this.selected_upsells = reset_upsells;
      this.selected_options = reset_options;
      this.filtered_products = reset_filtered;
    },
    toPrice(cents) {
      return Shopify.formatMoney(cents, this.money_format);
    },
    toggleModal() {
      this.modal_open = !this.modal_open;
    },
    setModalContent(data) {
      this.modal_content.heading = data.heading || "";
      this.modal_content.body = data.description || "";
      this.modal_content.image = data.image || "";
      this.modal_content.url = data.url || "";
      this.modal_content.price = data.price ? this.toPrice(data.price) : "";
      this.modal_content.type = data.type || "product";
      this.modal_open = true;
    },
  },
  delimiters: ["${", "}"],
});

app.component("step", {
  data() {
    return {
      selected_option: "",
      upsell_products: [],
    };
  },
  props: {
    step: Number,
    limit: Number,
    next: Function,
    prev: Function,
    direction: Number,

    options: Object,
    upsellOptions: Object,

    stepUpsell: Object,

    data: Object,

    currentKey: String,
    currentValue: String,
    currentUpsellKey: String,
    headings: Object,
    optionInfo: Object,

    currentOptions: Array,
    imageOptions: Object,

    selectProducts: Function,
    toPrice: Function,
  },
  template: "#vue-template--step",
  mounted() {
    //called going from final to step
    if (this.currentKey == "upsell") {
      this.selected_option = this.currentUpsellKey;

      if (this.stepUpsell && Object.keys(this.stepUpsell)[0]) {
        this.upsell_products = this.stepUpsell;
      } else {
        this.upsell_products = [];
      }
    } else {
      this.selected_option = this.currentOptions[this.step];
    }
  },
  watch: {
    step(curr, prev) {
      //set selected_option based off step changing (upsell has same value as previous required step)
      if (this.currentKey == "upsell") {
        this.selected_option = this.currentUpsellKey;
      } else {
        this.selected_option = this.currentOptions[curr];
      }
    },
    stepUpsell(upsell_prods, oldId) {
      if (upsell_prods) {
        this.upsell_products = upsell_prods;
      } else {
        this.upsell_products = [];
      }
    },
    currentUpsellKey(key, oldKey) {
      if (key) {
        this.selected_option = key;
      } else {
        this.selected_option = undefined;
      }
    },
  },
  computed: {
    currentProducts() {
      return this.options[this.currentOption];
    },
    currentOption() {
      return this.selected_option;
    },
    hasUpsell() {
      return this.upsell_products.length > 0;
    },
    selectedUpsellId() {
      return this.stepUpsell && this.stepUpsell.id ? this.stepUpsell.id : 0;
    },
    transitionName() {
      return this.direction > 0 ? "forward" : "backward";
    },
    upsellIds() {
      return this.upsell_products.map((product) => product.id);
    },
    upsellKeys() {
      return this.data.upsell_products.map((product) => product.key);
    },
  },
  methods: {
    optionClicked(key) {
      if (key == this.selected_option && this.upsell_products.length > 0) {
        //click same link, remove active and reset
        this.reset();
        return;
      }

      this.upsell_products = [];

      this.selected_option = key;
      console.log(this.upsellKeys.includes(key));
      if (
        !this.data.fold_out ||
        (this.data.fold_out && !this.upsellKeys.includes(key))
      ) {
        this.nextSlide();
      }
    },

    upsellClicked(key, product, upsell_index = 0, required = {}) {
      // return
      if (
        this.upsell_products &&
        this.upsellIds.includes(product.id) &&
        key == this.selected_option
      ) {
        this.selected_option = "";
        this.upsell_products = [];
        return;
      }

      this.selected_option = key;
      this.upsell_products[upsell_index] = product;

      if (Object.keys(required)[0]) {
        this.upsell_products[upsell_index + 1] = required;
      }

      console.log("THIS HERE");
      if (Object.keys(product)[0]) {
        this.nextSlide();
      }
    },
    nextSlide() {
      if (this.currentProducts && !this.currentProducts[0]) return;

      //deal with upsell
      if (this.currentKey == "upsell") {
        //if upsell is being save, set selected option and filtered to the previous options (basically a skip)
        var previous_selecting =
          this.currentOptions[this.step - 1] ||
          this.currentOptions[this.currentOptions.length - 1];
        this.$emit(
          "select-products",
          previous_selecting,
          this.options[previous_selecting],
          this.upsell_products,
          this.selected_option,
        );
      } else {
        // this.selectProducts(this.selected_option, this.currentProducts, this.upsell_product)
        this.$emit(
          "select-products",
          this.selected_option,
          this.currentProducts,
          this.upsell_products,
        );
      }

      this.reset();
    },
    prevSlide() {
      if (this.step - 1 < 0) return;

      this.prev();
      this.reset();
    },
    reset() {
      this.selected_option = "";
      this.upsell_products = [];
    },
  },
  emits: ["select-products", "set-modal"],
  delimiters: ["${", "}"],
});

const MountUpsell = {
  data() {
    return {
      //NAVIGATION
      active_filter: 0,
      current_products: [[], [], []],
      //FILTER
      filtered_mounts: [],
      selected_mounts: [],
      excluded_filters: [
        "Model",
        "Hole-Pattern",
        "Adapter-Plate",
        "Clamp-Range",
        "Ball-and-Socket-Size",
        "Device-Brand",
        "Thread-Pitch",
        "Length",
        "Product-Line",
      ],
      include_filters: ["Vehicle", "Location", "Socket-Arm-Length"],
      starting_filter: ["Vehicle"],
      show_prod_limit: 10,
      //CAR RELATED
      car_properties: ["make", "model", "year"],
      car_selected: [],
      car_products: [],
      car_filtered: [],
    };
  },
  props: {
    strikeMounts: Array,
    products: Object,
    required: Object,
    productTitle: Function,
    price: Function,
    currentId: Number,
    copy: Object,
    cars: Array,
  },
  mounted() {
    this.filtered_mounts = this.products;

    this.filterCars(this.cars);

    this.car_filtered = this.filterCars(this.cars);
    this.car_products[0] = this.currentCarValue(this.car_filtered); //filtered via make

    //set current for navigation change
    this.current_products[0] = this.strikeMounts;
  },
  computed: {
    mountsByFilter() {
      return this.filterMounts(this.filtered_mounts);
    },
  },
  watch: {
    filtered_mounts(new_set, old_set) {
      if (new_set.length <= this.show_prod_limit) {
        this.current_products[1] = new_set;
        this.$emit("set-products", new_set);
        this.$emit("set-required", {});
        this.$emit("reset-selected");
      }
    },
    active_filter(new_index, old_index) {
      //reset products when switching between options
      this.$emit("set-products", this.current_products[new_index]);

      if (new_index == 2 && this.current_products[new_index][0]) {
        this.$emit("set-required", this.required);
      } else {
        this.$emit("set-required", {});
      }
    },
  },
  methods: {
    setFilterActive(state) {
      this.active_filter = state;
    },
    setMountType(filter, key, products) {
      this.car_selected = [];
      this.selected_mounts.push(`${filter}__${key}`);
      this.filtered_mounts = products;
    },
    filterMounts(product_set) {
      let current_filtered = {};
      product_set.forEach((item) => {
        item.tags.forEach((tag) => {
          var tag_split = tag.split("__");
          var key = tag_split[0];
          var value = tag_split[1];

          if (!current_filtered[key]) {
            current_filtered[key] = {};
          }

          if (!current_filtered[key][value]) {
            current_filtered[key][value] = [];
          }

          current_filtered[key][value].push(item);
        });
      });
      return current_filtered;
    },
    removeFilter(tag) {
      //remove tag
      this.selected_mounts = this.selected_mounts.filter((curr_tag) => {
        return curr_tag != tag;
      });

      //refilter original products
      this.filtered_mounts = this.products.filter((product) => {
        for (let i = 0; i < this.selected_mounts.length; i++) {
          const tag = this.selected_mounts[i];
          if (product.tags.indexOf(tag) < 0) {
            return false;
          }
        }
        return true;
      });

      if (this.filtered_mounts.length > this.show_prod_limit) {
        this.$emit("reset-products");
      } else {
        this.current_products[1] = this.filtered_mounts;
      }
    },
    removeAllFilters() {
      this.selected_mounts = [];
      this.filtered_mounts = this.products;
      this.$emit("set-required", {});
      this.$emit("reset-selected");
      this.$emit("reset-products");
      this.current_products[1] = [];
    },
    classObj(key, filter) {
      let tag = `${filter}__${key}`;
      return {
        // 'active': this.isOptionActive(key),
        hidden: this.selected_mounts.includes(tag),
      };
    },
    readableTag(tag) {
      var tag_spaced = tag.replaceAll("-", " ");
      return tag_spaced.replace("__", ": ");
    },
    filterTotal(filter_items) {
      return Object.values(filter_items).reduce((prv, curr) => {
        return prv + curr.length;
      }, 0);
    },
    detailsOpen(filter) {
      return this.selected_mounts.join(",").includes(filter + "__");
    },
    filtersRemaining(items) {
      var has_filters = Object.values(items).filter((item) => {
        return item.length < this.filtered_mounts.length;
      });

      return has_filters.length != 0;
    },
    //car specific
    filterCars(car_products) {
      const car_properites = ["make", "model"];
      let organised_cars = [];
      // let make = ''
      // let model = ''
      // let year = ''

      //ClicOn No Holes Dash Mount for Mercedes Benz CLS-Class 05-10
      car_products.forEach((product) => {
        let make = "";
        let model = "";
        let year = "";
        let car_info = product.title.toLowerCase().split(" for ")[1];

        if (!car_info) {
          return;
        }
        if (car_info.includes("&")) {
          //some cradles cradles have multiple items in the title. Handle these individually
          var multi_cars = car_info.split(" & ");
          multi_cars.forEach((car_info) => {
            var sorted_car = this.sortCar(car_info);

            organised_cars.push({
              make: sorted_car.make,
              model: sorted_car.model,
              year: sorted_car.year,
              product,
            });
          });

          return;
        }

        var sorted_car = this.sortCar(car_info);

        organised_cars.push({
          make: sorted_car.make,
          model: sorted_car.model,
          year: sorted_car.year,
          product,
        });
      });

      return organised_cars;
    },
    sortCar(car_info) {
      var make = "";
      var model = "";
      var year = "";

      const two_name_make = ["mercedes", "land", "alfa"];
      //this will need to change for when there are multiple name titles!
      let car_info_array = car_info.split(" ");

      if (car_info_array.length == 3) {
        //know what each is
        make = car_info_array[0];
        model = car_info_array[1];
        year = car_info_array[2];
      } else {
        year = car_info_array[car_info_array.length - 1];
        make = car_info_array[0];

        var starting_model = 1;
        if (two_name_make.includes(car_info_array[0])) {
          //two part name
          make = car_info_array[0] + " " + car_info_array[1];
          starting_model = 2;
        }
        for (let i = starting_model; i < car_info_array.length - 1; i++) {
          model =
            model.length > 0
              ? model + " " + car_info_array[i]
              : car_info_array[i];
        }
      }
      return {
        make: make,
        model: model,
        year: year.replace(/[()]/g, ""),
      };
    },
    currentCarValue(cars) {
      //filter cars using current values
      let current_index = this.car_selected.length;
      let current_property = this.car_properties[current_index]; //make

      let filtered_cars = {};

      cars.forEach((obj) => {
        let car_value = obj[current_property];
        if (!filtered_cars[car_value]) {
          filtered_cars[car_value] = [];
        }

        filtered_cars[car_value].push(obj);
      });

      return filtered_cars;
    },
    handleCarChange(event, index) {
      if (this.car_selected[index]) {
        //already has values, reset future choices
        let reset_car_selected = [];
        let reset_car_products = [];
        for (let i = 0; i < index; i++) {
          reset_car_selected[i] = this.car_selected[i];
          // reset_car_products[i] = this.car_products[i]
        }
        this.car_selected = reset_car_selected;
        // this.car_products = reset_car_products
      }

      var select = event.target;
      var option = select.selectedOptions[0];

      if (!option) return;

      this.car_selected[index] = option.value;

      if (this.car_selected.length == this.car_properties.length) {
        //reset from previous state
        this.removeAllFilters();

        //selected final option
        var final_products = this.car_products[index][option.value].map(
          (item) => {
            return item.product;
          },
        );
        //car mount requires two product
        if (Object.keys(this.required)[0]) {
          this.$emit("set-required", this.required);
        }
        this.current_products[2] = final_products;
        this.$emit("set-products", final_products);
      } else {
        this.car_products[this.car_selected.length] = this.currentCarValue(
          this.car_products[index][option.value],
        );
      }
    },
    toTitleCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    alphabetical(object) {
      if (!object) return;
      return Object.keys(object)
        .sort()
        .reduce(function (acc, key) {
          acc[key] = object[key];
          return acc;
        }, {});
    },
    removeCar() {
      this.car_selected = [];
      this.$emit("reset-products");
      this.$emit("set-required", {});
    },
  },
  emits: [
    "info-clicked",
    "set-products",
    "reset-products",
    "set-required",
    "reset-selected",
  ],
  template: "#vue-template--mount",
  delimiters: ["${", "}"],
};

app.component("step-options", {
  data() {
    return {
      current_select_product: {},
      upsell_types: [],
      option_upsells: {}, //set as data object as mount step manipulates data (when filtering)
      required_upsell: {}, //some products require a second product to function
    };
  },
  props: {
    options: Object,
    upsells: Object,
    images: Object,
    headings: Object,
    infos: Object,
    foldOut: Boolean,

    selectedKey: String,
    selectedUpsellKey: String,
    selectedUpsellIds: Array,
    currentKey: String,

    setKey: Function,
    setUpsell: Function,
    price: Function,
  },
  mounted() {
    if (
      this.selectedUpsellKey == "select" &&
      this.selectedUpsellIds[0] &&
      this.upsells.select
    ) {
      var current_select = this.findMatchingProdId(
        this.selectedUpsellIds,
        this.upsells.select,
      );
      this.current_select_product = current_select.product;
    }

    if (this.currentKey != "upsell") {
      //for non-upsell steps, key must exist in products to display item
      let filtered_upsell = {};
      Object.keys(this.upsells).forEach((key) => {
        if (this.options[key]) {
          filtered_upsell[key] = this.upsells[key];
        }
      });
      //fetch upsells
      var upsell_handles = [];
      Object.values(filtered_upsell).forEach((upsell_array) => {
        upsell_array.forEach((upsell_handle) => {
          upsell_handles.push(upsell_handle);
        });
      });

      if (upsell_handles[0]) {
        this.fetchUpsells(upsell_handles).then((upsell_product_data) => {
          //find matching product from returned data
          Object.entries(filtered_upsell).forEach(([key, upsell_array]) => {
            upsell_array.forEach((upsell_handle, index) => {
              //3x loops :(, last week of development? :)
              var matching_product = upsell_product_data.find((product) => {
                return product.handle == upsell_handle;
              });
              if (matching_product) {
                filtered_upsell[key][index] = matching_product;
              }
            });
          });
          this.option_upsells = filtered_upsell;
        });
      }
    } else {
      //set keys to be used for displaying upsell options (need to be in separate containers)
      this.option_upsells = { ...this.upsells }; //immutable
    }
    this.upsell_types = Object.keys(this.upsells);
  },
  methods: {
    allOptions(current_upsells) {
      //included required in current options
      var required_upsell = this.required_upsell;

      if (
        typeof required_upsell == "undefined" ||
        !Object.keys(required_upsell)[0]
      ) {
        return current_upsells;
      }

      return { ...current_upsells, required_upsell };
    },
    isOptionActive(option) {
      //option is active if there is no upsell product and option matches
      //zero equals false
      return !this.selectedUpsellIds[0] && option == this.selectedKey;
    },
    isUpsellActive(option, product_id) {
      //upsell is active if there is an upsell product,  with an id that mataches and the option matches
      return (
        this.selectedUpsellIds.length > 0 &&
        option == this.selectedKey &&
        this.selectedUpsellIds.includes(product_id)
      );
    },
    handleUpsellClicked(key, prod) {
      if (prod.id == this.required_upsell.id) return;
      this.setUpsell(key, prod, 0, this.required_upsell);
    },
    handleOptionInfoClick(e, option) {
      e.stopPropagation();
      e.stopImmediatePropagation();

      var modal_data = {
        heading: option.heading,
        description: option.body,
        image: option.image.length != "" ? `${option.image}&width=500` : "",
        url: option.url,
      };
      this.$emit("set-modal", modal_data);
    },
    handleUpsellInfoClick(e, product) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      var modal_data = {
        heading: product.title,
        description: product.description,
        image:
          product.featured_image.length != ""
            ? `${product.featured_image}&width=500`
            : "",
        price: product.price,
        url: `/products/${product.handle}`,
      };
      this.$emit("set-modal", modal_data);
    },
    handleSelectUpsellChange(e, products) {
      var selected_option = e.currentTarget.selectedOptions[0];

      if (!selected_option) return;

      var prod_id = parseInt(selected_option.value);

      //find chosen product within data
      var selected_product = this.findMatchingProdId(prod_id, products);

      //saving key as select here will cause issues
      this.setUpsell("select", selected_product.product);
      this.current_select_product = selected_product.product;
    },
    findMatchingProdId(ids, products) {
      return products.find((item) => {
        return ids.includes(item.product.id);
      });
    },
    hasImage(key) {
      return (
        this.images[key] && (this.images[key].svg || this.images[key].image)
      );
    },
    productTitle(value) {
      if (!value) return;
      var limit = 30;

      if (value.length < limit) return value;

      return `${value.replace(/^(.{30}[^\s]*).*/, "$1")}...`;
    },
    //mount specific methods
    changeUpsellProducts(filtered_products) {
      //pass through filtered products that get displayed in place of base
      this.option_upsells.upsell = filtered_products;
    },
    resetUpsellProducts() {
      this.option_upsells.upsell = this.upsells.upsell;
    },
    resetSelectedProducts() {
      this.setUpsell(this.currentKey, {}, 0, {});
    },
    setRequiredUpsell(product) {
      //some upsell steps (car mount) require two products
      this.required_upsell = product;
    },
    fetchUpsells(handle_array) {
      //all_products is limited to 20 products (WTF), need to fetch products
      //https://github.com/Shopify/liquid/issues/1283

      var query = handle_array
        .map((handle) => `handle:'${handle}'`)
        .join(" OR ");

      var template_suffix = "custom";

      var url = `/search?view=${template_suffix}&type=product&q=${query}`;

      console.log(url, query);

      return fetch(url, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          return res;
        });
    },
  },
  components: {
    Mount: MountUpsell,
  },
  template: "#vue-template--options",
  emits: ["set-modal", "set-required"],
  delimiters: ["${", "}"],
});

app.component("step-counter", {
  props: {
    current: Number,
    limit: Number,
    keys: Array,
    currentValues: Array,
    progress: Number,
    seek: Function,
    upsells: Object,
    options: Array,
    stepData: Array,
  },
  computed: {
    activeSteps() {
      //store the index of the current loop but filter out any unset steps
      return this.currentValues.reduce((prev, curr, i) => {
        if (curr) {
          return [...prev, i];
        }
        return prev;
      }, []);
    },
  },
  methods: {
    handleClick(index) {
      this.seek(index);
    },
    itemState(index) {
      return {
        active: index == this.current,
        disabled: index == this.progress && index != this.current,
        current: index == this.progress,
        final: this.currentValues.length == this.limit + 1,
      };
    },
    stepValue(step_index) {
      //know the value of the current step by seeing the next steps filtered values
      if (this.keys[step_index] == "upsell") {
        if (this.upsells[step_index] && this.upsells[step_index][0]) {
          //has upsell, therefore use it https://stackoverflow.com/questions/5454235/shorten-string-without-cutting-words-in-javascript
          return (
            this.upsells[step_index][0]?.title?.replace(
              /^(.{11}[^\s]*).*/,
              "$1",
            ) || ""
          );
        } else {
          return "";
        }
      }

      return this.options[step_index] || "";
    },
    counterHeadingValue(index) {
      //Upsell steps have the key upsell but require a different name (ie mounts)
      if (
        this.stepData[index].headings &&
        this.stepData[index].headings.counter &&
        this.stepData[index].headings.counter != ""
      ) {
        return this.stepData[index].headings.counter;
      } else {
        return this.keys[index];
      }
    },
  },
  template: "#vue-template--counter",
  delimiters: ["${", "}"],
});

app.component("step-contact", {
  props: {
    current: Number,
  },
  emits: ["set-modal"],
  template: "#vue-template--contact",
  delimiters: ["${", "}"],
});

app.component("step-final", {
  data() {
    return {
      upsells: [],
      final_products: [],
      final_product: {},
      total_price: 0,
    };
  },
  props: {
    finalProducts: Array,
    finalUpsells: Array,
    script: String,
    toPrice: Function,
    generic: Object,
  },
  computed: {
    totalPrice() {
      var upsell_total = this.upsells.reduce((prev, current) => {
        if (current) {
          var inner_total = current.reduce((inner_prev, inner_current) => {
            if (inner_current) {
              return inner_prev + inner_current.price;
            } else {
              inner_prev;
            }
          }, 0);
          return prev + inner_total;
        } else {
          return prev;
        }
      }, 0);
      var final_product_price = this.final_product.price;
      return this.toPrice(upsell_total + final_product_price);
    },
  },
  mounted() {
    const product_form = document.querySelector(".cb-final product-form");

    if (product_form) {
      // need to initialize each time final mounts
      product_form.init();
    }

    this.upsells = [...this.finalUpsells];

    this.final_products = this.finalProducts.map((obj) => {
      //comes with meta field keys, just need products
      return obj.product;
    });

    var generic_options = this.final_products[0].collections.reduce(
      (prev, current) => {
        const handle = current.handle;

        if (Object.keys(this.generic).includes(handle)) {
          return [...prev, this.generic[handle]];
        } else {
          return prev;
        }
      },
      [],
    );

    if (generic_options.length > 0) {
      this.final_products = [...this.final_products, ...generic_options];
    }

    this.final_product = this.final_products[0];

    //set atc button
    const COPY_SOLD_OUT = "Sold out";
    const COPY_AVAILABLE = "Add to cart";
    const atc_button = product_form.querySelector(".product-form__submit");

    if (!atc_button) return;

    const atc_copy = atc_button.querySelector("span");

    if (this.final_product.available) {
      atc_button.removeAttribute("disabled");
      atc_copy.innerText = COPY_AVAILABLE;
    } else {
      atc_button.addAttribute("disabled");
      atc_copy.innerText = COPY_SOLD_OUT;
    }
  },
  methods: {
    setInputName(index, inner_index) {
      // +1 because base product is number 1
      if (inner_index > 0) {
        return `items[${inner_index}${index}][id]`;
      }
      return `items[${index}][id]`;
    },
    handleUpsellChange(event, index) {
      var input = event.target;
      var step_value = input.dataset.step;

      if (input.checked) {
        //add to upsell to recalculate
        this.upsells[index] = this.finalUpsells[index];

        //select matching required
        this.setMatchingInput(input, step_value, true);
      } else {
        //remove from upsell to recalculate
        this.upsells[index] = undefined;

        //select matching required
        this.setMatchingInput(input, step_value, false);
      }
    },
    setMatchingInput(current_input, step, check_state) {
      var matching_values = document.querySelectorAll(
        `.cb-final .final-upsell__input[data-step="${step}"]`,
      );

      Array.from(matching_values).forEach((matching) => {
        if (matching != current_input) {
          matching.checked = check_state;
        }
      });
    },
    setFinalProduct(index) {
      this.final_product = this.final_products[index];
    },
    submitForm() {
      var form = document.querySelector("product-form form");

      if (!form) return;

      form.submit();
    },
  },
  emits: ["prev"],
  template: "#vue-template--final",
  delimiters: ["${", "}"],
});

app.component("step-modal", {
  props: {
    open: Boolean,
    content: Object,
  },
  mounted() {
    document.body.classList.add("noscroll");
  },
  unmounted() {
    document.body.classList.remove("noscroll");
  },
  template: "#vue-template--modal",
  delimiters: ["${", "}"],
});

app.mount("#app");
